module.exports = __webpack_public_path__ + "img/bg-014.61b79ff2.jpg";